import { Button, DatePicker, notification, Select, Input, Form, message, Typography, Card, Avatar, Col, Row, List, Upload, Modal } from "antd"
import { ArrowLeftOutlined, EditOutlined, EyeInvisibleOutlined, EyeTwoTone } from '@ant-design/icons';
import Title from "antd/es/typography/Title"
import { CreateAccount, GetAccountByID, GetAccountsBySize, GetAllPaymentByID, GetAllRoles, GetGroupbyRetreatID, GetHistoryRetreats, GetProgressRetreats, UpdateAccount, UpdateMonkGroup } from "../../../api/AdminService"
import { useNavigate, useParams } from "react-router-dom"
import dayjs from "dayjs"
import { useEffect, useRef, useState } from "react"
import { Option } from "antd/es/mentions"
import LoadingPage from "../../../Components/LoadingPage/LoadingPage";


const { Text } = Typography
const AdminDetailGroup = () => {
    const navigate = useNavigate()
    const [form] = Form.useForm()
    const { id } = useParams();
    const [Monk, setMonk] = useState([]);
    const [selectedMonk, setSelectedMonk] = useState();
    const [MonkGroup, setMonkGroup] = useState();
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [loading, setLoading] = useState(true);
    const getAccounts = (size) => {
        try {
            GetAccountsBySize(size).then(res => {
                if (res.status === 200) {
                    const monks = res.data.data.filter(account => account.role === 'Monk');
                    console.log(monks);
                    setMonk(monks);
                }
            })
        } catch (err) {
            console.log(err)
        }
    }

    const GetGroupByID = (id) => {
        console.log(id)
        GetGroupbyRetreatID(id).then(res => {
            if (res.status === 200) {
                console.log(res.data.data[0])
                const fullname = (res.data.data[0]?.monk)
                    ? (res.data.data[0]?.monk.firstName + ' ' + res.data.data[0]?.monk.lastName)
                    : 'unassigned';
                if (res.data.data[0]?.monk) {
                    setMonkGroup(res.data.data[0]?.monk.id);
                }
                form.setFieldsValue({
                    name: res.data.data[0]?.name,
                    monk: fullname,
                    retreatGroupMembers: res.data.data[0]?.retreatGroupMembers,
                    room: res.data.data[0]?.room,
                })
                setLoading(false)
            }
        }).catch(err => {
            console.log(err)
        })
    }

    useEffect(() => {
        getAccounts(1000);
        GetGroupByID(id);
    }, [])

    const showModal = (monkId) => {
        setSelectedMonk(monkId);
        setIsModalVisible(true);
    };

    const handleOk = () => {
        const formData = new FormData();
        formData.append('retreatGroupId', id);
        formData.append('monkId', selectedMonk);

        // Check FormData contents
        for (let [key, value] of formData.entries()) {
            console.log(`${key}: ${value}`);
        }

        UpdateMonkGroup(formData).then(res => {
            if (res.status === 200) {
                notification.success({
                    message: "Update Monk for Group Successfully"
                });
                setIsModalVisible(false);
                GetGroupByID(id);
            }
        }).catch(err => {
            notification.error({
                message: `${err.response.data.message}`
            });
            console.log(err)
        });
    };

    const handleCancel = () => {
        setIsModalVisible(false);
    };

    return (
        <div style={{ minHeight: '96.5vh', Width: '100%' }}>
            <Button
                icon={<ArrowLeftOutlined />}
                onClick={() => navigate(-1)}
                style={{ marginBottom: 16 }}
            >
                Go Back
            </Button>

            <div style={{ maxWidth: 600, margin: 'auto', padding: '24' }}>
                <Title level={2} style={{ textAlign: 'left', marginBottom: '24' }}>
                    Group
                </Title>
                {loading ? (<LoadingPage />
                ) : (
                    <div style={{ marginBottom: '20px' }}>
                        <Form
                            form={form}
                            name="wrap"
                            labelAlign="left"
                            labelWrap
                            labelCol={{ flex: '150px' }}
                        >
                            <Card title="Basis Information" style={{ border: '1px solid #d9d9d9', borderRadius: '4px', marginBottom: 20 }}>
                                <Form.Item name={"name"} label={<span style={{ fontSize: '16px' }}>Group Name</span>}
                                    style={{ borderBottom: '1px solid #d9d9d9', paddingBottom: 8 }}
                                >
                                    <Input disabled
                                        style={{
                                            border: 'none',
                                            color: 'rgba(0, 0, 0, 0.88)',
                                            width: '100%',
                                            backgroundColor: 'white',
                                            textAlign: 'left'
                                        }}

                                    />
                                </Form.Item>
                                <Form.Item name={"monk"} label={<span style={{ fontSize: '16px' }}>Monk Name</span>}
                                >
                                    <Input disabled
                                        value={form.getFieldValue("monk")}
                                        style={{
                                            border: 'none',
                                            color: 'rgba(0, 0, 0, 0.88)',
                                            width: 'calc(100% - 40px)',
                                            backgroundColor: 'white',
                                            textAlign: 'left'
                                        }}


                                    />
                                    <EditOutlined onClick={() => showModal(MonkGroup)} style={{ cursor: 'pointer', marginLeft: '8px' }} />
                                </Form.Item>
                            </Card>
                            <Card title="Group member" style={{ border: '1px solid #d9d9d9', borderRadius: '4px', marginBottom: 20 }}>
                                <List
                                    dataSource={form.getFieldValue('retreatGroupMembers')}
                                    renderItem={Member => (
                                        <List.Item key={Member.member.id}>
                                            <List.Item.Meta
                                                // avatar={<img src={Member.retreatImages[0].url} style={{ width: 100, height: 100, borderRadius: '4px' }} />}
                                                title={Member.member.email}
                                                description={
                                                    <>
                                                        <p>Phone: {Member.member.phoneNumber}</p>
                                                        <p>Gender: {Member.member.gender}</p>
                                                    </>
                                                }
                                            />
                                        </List.Item>
                                    )}
                                />
                            </Card>
                        </Form>

                    </div>
                )}

            </div>
            <Modal title="Update Monk/Nun" open={isModalVisible} onCancel={handleCancel}
                footer={() => (
                    <>
                        <Button onClick={handleCancel}>Cancel</Button>
                        <Button type="primary" onClick={handleOk}>Confirm</Button>
                    </>
                )}>
                <Select
                    placeholder="Choose a monk"
                    onChange={e => setSelectedMonk(e)}
                    value={selectedMonk}
                    style={{ width: '100%' }}
                >
                    {Monk.map(monk => (
                        <Option key={monk.id} value={monk.id}>
                            {`${monk.firstName} ${monk.lastName}`}
                        </Option>
                    ))}
                </Select>

            </Modal>
        </div>
    )

}
export default AdminDetailGroup